import { createAction } from 'typesafe-actions';
import { Winners } from 'constants/common';
import { ACTIONS } from './types';

export const updateBallsCounterAction = createAction(ACTIONS.UPDATE_BALLS_COUNTER)<{
  winner: Winners;
}>();

export const setInitialCounterStateAction = createAction(ACTIONS.SET_INITIAL_COUNTER_STATE)<{
  winnersData: Winners[];
}>();

export const resetCounterStateAction = createAction(ACTIONS.RESET_COUNTER_STATE)();
